// load-more.js (updated)
class LoadMore {
  constructor() {
    try {
      this.button = document.querySelector('.load-more-button');
      this.productGrid = document.querySelector('[data-product-grid]');
      this.nextLink = document.querySelector('link[rel="next"]');
      if (this.button && this.productGrid && this.nextLink) this.init();
    } catch (error) {
      console.error('LoadMore Init Error:', error);
    }
  }

  init() {
    this.button.addEventListener('click', (e) => this.handleLoadMore(e));
  }

  async handleLoadMore(e) {
    try {
      e.preventDefault();
      this.toggleLoading(true);
      
      const response = await fetch(this.nextLink.href);
      const html = await response.text();
      const newDoc = new DOMParser().parseFromString(html, 'text/html');
      
      // Append new products
      const newProducts = newDoc.querySelector('[data-product-grid]').innerHTML;
      this.productGrid.insertAdjacentHTML('beforeend', newProducts);
      
      // Update next link
      const newNextLink = newDoc.querySelector('link[rel="next"]');
      if (newNextLink) {
        this.nextLink.href = newNextLink.href;
      } else {
        this.button.remove();
        this.nextLink.remove();
      }
    } catch (error) {
      console.error('Load More Error:', error);
      this.button.textContent = 'Error - Click to Retry';
    } finally {
      this.toggleLoading(false);
    }
  }

  toggleLoading(isLoading) {
    this.button.disabled = isLoading;
    this.button.querySelector('.loading-spinner').classList.toggle('hidden', !isLoading);
  }
}

// Initialize
if (document.querySelector('.template-collection')) new LoadMore();